import { trackUserActivity, UserActivityEvent } from '@crehana/analytics';

import buyProduct, { trackProduct } from 'Jsx/Utils/buyProduct';

import type { CourseCardProps } from '../../../types';

interface IUseCourseMethods extends Partial<CourseCardProps> {
  courseId?: number;
}

const useCouseMethods = ({
  courseId,
  addCourseToCart,
  removeCourseFromCart,
  urlToBuyNow,
  onClickBuyNow,
  product,
  beforeBuy,
  title,
  inShoppingCart,
}: IUseCourseMethods) => {
  const removeCourseFromCartWithTrack = () => {
    if (removeCourseFromCart) {
      removeCourseFromCart({
        courseId: courseId as number,
      });
    }
  };

  const addCourseToCartWithTrack = () => {
    if (addCourseToCart) {
      addCourseToCart({
        courseId: courseId as number,
      });
    }
  };

  const handleAddToCart = () => {
    const buyUrl = `/shopping-cart/course/${courseId}`;

    if (inShoppingCart) {
      return removeCourseFromCartWithTrack();
    }
    if (addCourseToCart) {
      return addCourseToCartWithTrack();
    }

    window.location.href = buyUrl;
  };

  const handleDirectBuyButton = () => {
    if (beforeBuy) {
      beforeBuy();
    }
    if (onClickBuyNow) {
      if (product) {
        trackProduct(product);
      }

      onClickBuyNow({
        itemId: courseId as number,
        itemType: 'course',
        itemData: {
          itemId: courseId || 0,
          itemType: 'course',
        },
      });
    } else if (product && urlToBuyNow) {
      buyProduct(urlToBuyNow, product);
    } else {
      trackUserActivity({
        event: UserActivityEvent.CLICK,
        data: {
          product_id: courseId!,
          product_name: title!,
          item_type: 'course',
          item_path: window.location.pathname,
        },
        nextUrl: urlToBuyNow,
      });
    }
  };

  return {
    handleAddToCart,
    handleDirectBuyButton,
  };
};

export default useCouseMethods;
